import PocketBase from 'pocketbase';
import { 
  SUPPORT_PB_URL, 
  SUPPORT_APP_ID 
} from '../config/constants';

// Initialize separate PocketBase instance for Support Hub
const supportPb = new PocketBase(SUPPORT_PB_URL);

// Step 1: Resolve App Record ID
export const resolveSupportAppId = async () => {
  try {
    const result = await supportPb.collection('apps').getList(1, 1, {
      filter: `(appId="${SUPPORT_APP_ID}") && (isActive=true)`
    });

    if (result.items.length > 0) {
      return result.items[0].id;
    }
    return null;
  } catch (error) {
    console.error("Failed to resolve Support App ID:", error);
    throw new Error("Could not connect to Support Service.");
  }
};

// Step 2: Create Ticket
export const createSupportTicket = async (formData) => {
  try {
    return await supportPb.collection('tickets').create(formData);
  } catch (error) {
    console.error("Failed to create ticket:", error);
    throw new Error(error.message || "Failed to submit ticket.");
  }
};

// Step 2b: Verify Ticket (Fetch by ID)
export const fetchSupportTicketById = async (id) => {
  try {
    return await supportPb.collection('tickets').getOne(id);
  } catch (error) {
    console.warn("Failed to fetch ticket verification:", error);
    return null;
  }
};

// Step 3: Create Initial Log Entry
export const createSupportLog = async (ticketId, requesterName, requesterEmail) => {
  try {
    const payload = {
      ticket: ticketId,
      authorType: "EndUser",
      authorName: requesterName,
      authorEmail: requesterEmail,
      message: "Ticket submitted from BPAS Client Hub in app support",
      isInternal: false
    };
    return await supportPb.collection('ticket_logs').create(payload);
  } catch (error) {
    // Non-blocking error, just log it
    console.warn("Failed to create support log:", error);
  }
};